/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Device } from '../../models/device';

export interface GetDevice$Params {

/**
 * Id of a resource.
 */
  id: string;

/**
 * Include device associations
 */
  include_associations?: boolean;
}

export function getDevice(http: HttpClient, rootUrl: string, params: GetDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<Device>> {
  const rb = new RequestBuilder(rootUrl, getDevice.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.query('include_associations', params.include_associations, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Device>;
    })
  );
}

getDevice.PATH = '/api/v1/devices/{id}';
